import { REQUEST, USER_LOG_OUT } from '../actions/action_types';
import * as PRODCUT from '../actionTypes/ec';
import * as FOLLOWING from '../actionTypes/following';
import * as PROFILE from '../actionTypes/profile';
import * as TRIP from '../actionTypes/trip';
import * as RESET from '../actionTypes/reset';
import * as NOTIFICATION from '../actionTypes/notification';
import * as POI_DETAIL from '../actionTypes/poiDetail';
import * as REWARD_POINTS from '../actionTypes/rewardPoints';

/*
漸進移除 reducer request_state_reducer 內容過來
request_state_reducer 全部混在一起 非常亂 而且還是物件形式
先前開發將 API 狀態移進該頁 reducer 但應該都移回此 reducer

兩點注意：
  1. 按照目前 API server 分類
  2. 只能放 API 狀態 不要放參數包含 token、queryString、id 有的沒有的
  3. 若從某個頁面離開，要將該頁面打過 API 狀態都還原成 INIT 初始值避免下次進入該頁面就不打 API 了
  4. 為避免從 actionTypes/product import 太多行 code，一律 * as XXX 的方式 import 進來
 */

const initState = {
  postSocialCopy: REQUEST.INIT,
  getGroupMembers: REQUEST.INIT,
  getPublicCollections: REQUEST.INIT,
  getPoisOfTrip: REQUEST.INIT,
  addProductToTrip: REQUEST.INIT,
  getProfileFans: REQUEST.INIT,
  getProfileFollowings: REQUEST.INIT,
  getAccountFans: REQUEST.INIT,
  getAccountFollowings: REQUEST.INIT,
  postFollowing: REQUEST.INIT,
  getRewardPointsBalance: REQUEST.INIT,
  getNotificationList: REQUEST.INIT,
  getCountOfInvitations: REQUEST.INIT,
  uploadAvatarStatus: REQUEST.INIT,
  uploadProfileCoverStatus: REQUEST.INIT,
  addPoiToMyCollectionStatus: REQUEST.INIT,
  changeNickNameStatus: REQUEST.INIT
};
const copyState = JSON.parse(JSON.stringify(initState));

export default (state = copyState, action) => {
  switch (action.type) {
    // copyProduct
    case PRODCUT.COPY_PRODUCT.INIT:
      return {
        ...state,
        postSocialCopy: REQUEST.INIT
      };
    case PRODCUT.COPY_PRODUCT.LOADING:
      return {
        ...state,
        postSocialCopy: REQUEST.LOADING
      };
    case PRODCUT.COPY_PRODUCT.SUCCESS:
      return {
        ...state,
        postSocialCopy: REQUEST.SUCCESS
      };
    case PRODCUT.COPY_PRODUCT.FAIL:
      return {
        ...state,
        postSocialCopy: REQUEST.FAIL
      };

    //   getGroupMembers
    case PROFILE.GET_PROFILE_MEMBERS.INIT:
      return {
        ...state,
        getGroupMembers: REQUEST.INIT
      };
    case PROFILE.GET_PROFILE_MEMBERS.LOADING:
      return {
        ...state,
        getGroupMembers: REQUEST.LOADING
      };
    case PROFILE.GET_PROFILE_MEMBERS.SUCCESS:
      return {
        ...state,
        getGroupMembers: REQUEST.SUCCESS
      };
    case PROFILE.GET_PROFILE_MEMBERS.FAIL:
      return {
        ...state,
        getGroupMembers: REQUEST.FAIL
      };
    case PROFILE.GET_PROFILE_MEMBERS.NEXT_LOADING:
      return {
        ...state,
        getGroupMembers: REQUEST.LOADING
      };
    case PROFILE.GET_PROFILE_MEMBERS.NEXT_SUCCESS:
      return {
        ...state,
        getGroupMembers: REQUEST.SUCCESS
      };

    // getProfileFans
    case PROFILE.GET_PROFILE_FANS.LOADING:
      return {
        ...state,
        getProfileFans: REQUEST.LOADING
      };
    case PROFILE.GET_PROFILE_FANS.SUCCESS:
      return {
        ...state,
        getProfileFans: REQUEST.SUCCESS
      };
    case PROFILE.GET_PROFILE_FANS.FAIL:
      return {
        ...state,
        getProfileFans: REQUEST.FAIL
      };
    case PROFILE.GET_PROFILE_FANS.NEXT_LOADING:
      return {
        ...state,
        getProfileFans: REQUEST.LOADING
      };
    case PROFILE.GET_PROFILE_FANS.NEXT_SUCCESS:
      return {
        ...state,
        getProfileFans: REQUEST.SUCCESS
      };
    case PROFILE.GET_PROFILE_FANS.NEXT_FAIL:
      return {
        ...state,
        getProfileFans: REQUEST.FAIL
      };
    // getProfileFollowings
    case PROFILE.GET_PROFILE_FOLLOWINGS.LOADING:
      return {
        ...state,
        getProfileFollowings: REQUEST.LOADING
      };
    case PROFILE.GET_PROFILE_FOLLOWINGS.SUCCESS:
      return {
        ...state,
        getProfileFollowings: REQUEST.SUCCESS
      };
    case PROFILE.GET_PROFILE_FOLLOWINGS.FAIL:
      return {
        ...state,
        getProfileFollowings: REQUEST.FAIL
      };
    case PROFILE.GET_PROFILE_FOLLOWINGS.NEXT_LOADING:
      return {
        ...state,
        getProfileFollowings: REQUEST.LOADING
      };
    case PROFILE.GET_PROFILE_FOLLOWINGS.NEXT_SUCCESS:
      return {
        ...state,
        getProfileFollowings: REQUEST.SUCCESS
      };
    case PROFILE.GET_PROFILE_FOLLOWINGS.NEXT_FAIL:
      return {
        ...state,
        getProfileFollowings: REQUEST.FAIL
      };

    // getAccountFans
    case FOLLOWING.GET_ACCOUNT_FANS.LOADING:
      return {
        ...state,
        getAccountFans: REQUEST.LOADING
      };
    case FOLLOWING.GET_ACCOUNT_FANS.SUCCESS:
      return {
        ...state,
        getAccountFans: REQUEST.SUCCESS
      };
    case FOLLOWING.GET_ACCOUNT_FANS.FAIL:
      return {
        ...state,
        getAccountFans: REQUEST.FAIL
      };

    // getAccountFollowings
    case FOLLOWING.GET_ACCOUNT_FOLLOWINGS.LOADING:
      return {
        ...state,
        getAccountFollowings: REQUEST.LOADING
      };
    case FOLLOWING.GET_ACCOUNT_FOLLOWINGS.SUCCESS:
      return {
        ...state,
        getAccountFollowings: REQUEST.SUCCESS
      };
    case FOLLOWING.GET_ACCOUNT_FOLLOWINGS.FAIL:
      return {
        ...state,
        getAccountFollowings: REQUEST.FAIL
      };
    case PROFILE.SET_CURRENT_PROFILE_FOLLOWINGS.LOADING:
    case FOLLOWING.SET_FOLLOWING.LOADING:
      return {
        ...state,
        postFollowing: REQUEST.LOADING
      };
    case PROFILE.SET_CURRENT_PROFILE_FOLLOWINGS.SUCCESS:
    case FOLLOWING.SET_FOLLOWING.SUCCESS:
      return {
        ...state,
        postFollowing: REQUEST.SUCCESS
      };
    case PROFILE.SET_CURRENT_PROFILE_FOLLOWINGS.FAIL:
    case FOLLOWING.SET_FOLLOWING.FAIL:
      return {
        ...state,
        postFollowing: REQUEST.FAIL
      };
    // getNotificationList
    case NOTIFICATION.FETCH_NOTIFICATION_LIST.LOADING:
      return {
        ...state,
        getNotificationList: REQUEST.LOADING
      };

    case NOTIFICATION.FETCH_NOTIFICATION_LIST.SUCCESS:
      return {
        ...state,
        getNotificationList: REQUEST.SUCCESS
      };

    case NOTIFICATION.FETCH_NOTIFICATION_LIST.FAIL:
      return {
        ...state,
        getNotificationList: REQUEST.FAIL
      };
    // getCountOfInvitations
    case NOTIFICATION.GET_NOTIFICATION_COUNT.LOADING:
      return {
        ...state,
        getCountOfInvitations: REQUEST.LOADING
      };

    case NOTIFICATION.GET_NOTIFICATION_COUNT.SUCCESS:
      return {
        ...state,
        getCountOfInvitations: REQUEST.SUCCESS
      };

    case NOTIFICATION.GET_NOTIFICATION_COUNT.FAIL:
      return {
        ...state,
        getCountOfInvitations: REQUEST.FAIL
      };

    // addProductToTrip
    case TRIP.ADD_PRODUCT_TO_TRIP.INIT:
      return {
        ...state,
        addProductToTrip: REQUEST.INIT
      };
    case TRIP.ADD_PRODUCT_TO_TRIP.LOADING:
      return {
        ...state,
        addProductToTrip: REQUEST.LOADING
      };
    case TRIP.ADD_PRODUCT_TO_TRIP.SUCCESS:
      return {
        ...state,
        addProductToTrip: REQUEST.SUCCESS
      };
    case TRIP.ADD_PRODUCT_TO_TRIP.FAIL:
      return {
        ...state,
        addProductToTrip: REQUEST.FAIL
      };
    // todo: 將 itinerary getPoisOfTrip api 狀態也遷移過來
    case PRODCUT.FETCH_CURRENT_TRIP.INIT:
      return {
        ...state,
        getPoisOfTrip: REQUEST.INIT
      };
    case PRODCUT.FETCH_CURRENT_TRIP.LOADING:
      return {
        ...state,
        getPoisOfTrip: REQUEST.LOADING
      };

    case PRODCUT.FETCH_CURRENT_TRIP.SUCCESS:
      return {
        ...state,
        getPoisOfTrip: REQUEST.SUCCESS
      };

    case PRODCUT.FETCH_CURRENT_TRIP.FAIL:
      return {
        ...state,
        getPoisOfTrip: REQUEST.FAIL
      };

    // unmount page so reset api request
    case RESET.RESET_PAGE.PROFILE:
      return {
        ...state,
        getGroupMembers: REQUEST.INIT
      };
    case RESET.RESET_PAGE.NOTIFICATION:
      return {
        ...state,
        getNotificationList: REQUEST.INIT,
        getCountOfInvitations: REQUEST.INIT
      };
    case USER_LOG_OUT:
      return {
        ...state,
        getFans: REQUEST.INIT,
        getFollowing: REQUEST.INIT
      };
    case PROFILE.UPLOAD_AVATAR.LOADING:
      return {
        ...state,
        uploadAvatarStatus: REQUEST.LOADING
      };

    case PROFILE.UPLOAD_AVATAR.SUCCESS:
      return {
        ...state,
        uploadAvatarStatus: REQUEST.SUCCESS
      };

    case PROFILE.UPLOAD_AVATAR.FAIL:
      return {
        ...state,
        uploadAvatarStatus: REQUEST.FAIL
      };
    case PROFILE.RESET_UPLOAD_AVATAR_STATUS:
      return {
        ...state,
        uploadAvatarStatus: REQUEST.INIT
      };
    case PROFILE.UPLOAD_PROFILE_COVER.LOADING:
      return {
        ...state,
        uploadProfileCoverStatus: REQUEST.LOADING
      };

    case PROFILE.UPLOAD_PROFILE_COVER.SUCCESS:
      return {
        ...state,
        uploadProfileCoverStatus: REQUEST.SUCCESS
      };

    case PROFILE.UPLOAD_PROFILE_COVER.FAIL:
      return {
        ...state,
        uploadProfileCoverStatus: REQUEST.FAIL
      };
    case PROFILE.RESET_UPLOAD_PROFILE_COVER_STATUS:
      return {
        ...state,
        uploadProfileCoverStatus: REQUEST.INIT
      };
    case POI_DETAIL.ADD_POI_TO_MY_COLLECTION.INIT:
      return {
        ...state,
        addPoiToMyCollectionStatus: REQUEST.INIT
      };
    case POI_DETAIL.ADD_POI_TO_MY_COLLECTION.LOADING:
      return {
        ...state,
        addPoiToMyCollectionStatus: REQUEST.LOADING
      };
    case POI_DETAIL.ADD_POI_TO_MY_COLLECTION.FAIL:
      return {
        ...state,
        addPoiToMyCollectionStatus: REQUEST.FAIL
      };
    case POI_DETAIL.ADD_POI_TO_MY_COLLECTION.SUCCESS:
      return {
        ...state,
        addPoiToMyCollectionStatus: REQUEST.SUCCESS
      };

    case PROFILE.CHANGE_NICKNAME.LOADING:
      return {
        ...state,
        changeNickNameStatus: REQUEST.LOADING
      };

    case PROFILE.CHANGE_NICKNAME.SUCCESS:
      return {
        ...state,
        changeNickNameStatus: REQUEST.SUCCESS
      };

    case PROFILE.CHANGE_NICKNAME.FAIL:
      return {
        ...state,
        changeNickNameStatus: REQUEST.FAIL
      };

    case REWARD_POINTS.FETCH_REWARD_POINTS.LOADING:
      return {
        ...state,
        getRewardPointsBalance: REQUEST.LOADING
      };
    case REWARD_POINTS.FETCH_REWARD_POINTS.SUCCESS:
      return {
        ...state,
        getRewardPointsBalance: REQUEST.SUCCESS
      };
    case REWARD_POINTS.FETCH_REWARD_POINTS.FAIL:
      return {
        ...state,
        getRewardPointsBalance: REQUEST.FAIL
      };
    default:
      return state;
  }
};
